import { Box, Tooltip, Typography } from '@mui/material';
import { TournamentTeamStatus as TeamStatus } from '@okletsplay/core';
import { TournamentTeamEntity } from 'app/interfaces/entity';
import classNames from 'classnames';
import React, { FC, useMemo } from 'react';
import { TeamIcon } from 'shared/components/TeamIcon';
import { TournamentTeamStatus } from '../TournamentTeamStatus';
import { useStyles } from './TournamentTeamCardHeader.styles';

interface TournamentTeamCardHeaderProps {
  team: TournamentTeamEntity;
  withStatus?: boolean;
}

export const TournamentTeamCardHeader: FC<TournamentTeamCardHeaderProps> = ({
  team,
  withStatus = true,
}) => {
  const { classes } = useStyles();

  const isDisqualifiedTeam = useMemo(() => team?.status === TeamStatus.Disqualified, [team]);

  const tooltipTitle = useMemo(
    () => (isDisqualifiedTeam ? `${team?.name} - ${team.status}` : team?.name),
    [isDisqualifiedTeam, team]
  );

  if (!team?.name) {
    return null;
  }

  return (
    <Box className={classes.root}>
      <Box className={classes.headerContainer}>
        <TeamIcon mr={1} team={team} />
        <Tooltip title={tooltipTitle}>
          <Typography
            className={classNames(classes.teamName, { [classes.disqualified]: isDisqualifiedTeam })}
          >
            {team?.name}
          </Typography>
        </Tooltip>
      </Box>
      {withStatus && (
        <Box className={classes.statusContainer}>
          <Typography color="text.disabled">{`#${team?.index}`}</Typography>
          <TournamentTeamStatus status={team?.status} />
        </Box>
      )}
    </Box>
  );
};
